<template>
<div style="position:relative">
  <div v-if="per_page">
    <b-button size="sm" class="pnthin"
      variant="primary"
      :disabled="cur_page <= 0"
      @click="prevPage"
    >
      Prev
    </b-button>
    <span>
      {{cur_page+1}}
    </span>
    <b-button size="sm" class="pnthin"
      variant="primary"
      :disabled="!more && (cur_page+1) >= last_page"
      @click="nextPage"
    >
      Next
    </b-button>
  </div>
  <b-table
     striped
     hover
     show-empty
     stacked="sm"
     :items="tab"
     :fields="tabFields"
     small>
       <template v-slot:cell(_label)="row">
         <div @click="row_selected('_label',row.item)"
           :style="labelStyle">
           {{row.value}}
         </div>
       </template>
       <template v-slot:cell(_ctrl)="row">
         <div  style="position:relative;float:right;">
            <b-button size="sm"
              v-if="row.value.preview"
              variant="primary"
              style="padding:0 0.25rem;color:#0062cc;background-color:transparent;font-family:'Material Icons';"
              @click="row_preview(row.item)"
              >
              visibility
            </b-button>
            <b-button size="sm"
              v-if="row.value.download"
              variant="primary"
              style="padding:0 0.25rem;color:#0062cc;background-color:transparent;font-family:'Material Icons';"
              @click="row_download(row.item)"
              >
              file_download
            </b-button>
            <confirm-del size='sm'
               v-if="row.value.trash"
               timeout="2000"
               :clear="row.value.id"
               v-on:confirmed-delete="row_trashed(row.item)">
            </confirm-del>
         </div>
       </template>
  </b-table>
</div>
</template>

<script>

import ConfirmDel from "../components/ConfirmDel";

export default {
  name: "EditList",
  props: [ "per_page" ],
  components: {
    ConfirmDel,
  },
  watch: {
  },
  data() {
    return  {
       labelStyle: "width:100%;",
       full_tab: [],
       tab: [],
       tabFields: [
         {key:"_label", label:""},
         {key:"_ctrl", label:""},
       ],
       more: true,
       cur_page:0,
       last_page:null,
    };
  },
  computed: {
  },
  mounted: function() {
    let vue = this;
    //console.log("editlist mounted");
    vue.$emit("setup",vue);
  },
  methods: {
    reset: function() {
      this.tab = this.full_tab = [];
      this.more = true;
      this.last_page = null;
      this.cur_page = 0;
      this.updateTab();
    },
    nomore: function() {
      /* Means that no more 'fetchMore' are required. The actual
       *   last_page must also be calculated in add()/remove() because
       *   more may still need to be added from the last fetch OR
       *   more may be manually added/removed */
      this.more = false;
      this.last_page = Math.ceil(this.full_tab.length / this.per_page);
    },
    add: function(item) {
      let vue = this;
      //console.log("add_row",JSON.stringify(item));
      item._label = item._label || "no-label";
      item._ctrl = item._ctrl || {};
      item._ctrl.id = 0;
      vue.full_tab.push(item);
      if (!vue.more) {
        vue.last_page = Math.ceil(vue.full_tab.length / vue.per_page);
      }
      vue.updateTab();
    },
    remove: function(item) {
      let vue = this;
      //console.log("remove_row",JSON.stringify(item));
      item._ctrl.del = true;
      vue.full_tab = vue.full_tab.filter(function(t) {
        /* Reset trash icon state */
        t._ctrl.id++;
        return !t._ctrl.del;
      });
      if (!vue.more) {
        vue.last_page = Math.ceil(vue.full_tab.length / vue.per_page);
        if (vue.cur_page > 0 && vue.cur_page >= vue.last_page) {
           vue.cur_page--;
        }
      }
      vue.updateTab();
    },
    refresh: function(item) {
      /* Re-show trash icon, e.g. if delete failed */
      item._ctrl.id++;
    },
    getList: function() {
      let vue = this;
      let list = [];
      let skip = ["_ctrl","_label"];
      vue.full_tab.forEach(function(item) {
        let n = {};
        Object.keys(item).forEach(function(field) {
          if (skip.includes(field)) { return; }
          n[field] = item[field];
        });
        list.push(n);
      });
      return list;
    },

    /* INTERNAL */
    row_selected: function(fieldname, item) {
      let vue = this;
      //console.log("select",fieldname);
      if (vue.cur_select) {
        vue.$emit("action",vue,"deselected",vue.cur_select);
      }
      vue.cur_select = item;
      vue.$emit("action",vue,"selected",item);
    },
    row_trashed: function(item) {
      let vue = this;
      //console.log("trash");
      if (vue.cur_select) {
        vue.$emit("action",vue,"deselected",vue.cur_select);
        vue.cur_select = null;
      }
      vue.$emit("action",vue,"trashed",item);
    },
    row_download: function(item) {
      let vue = this;
      //console.log("download");
      vue.$emit("action",vue,"download",item);
    },
    row_preview: function(item) {
      let vue = this;
      //console.log("preview");
      vue.$emit("action",vue,"preview",item);
    },
    updateTab: function() {
      let vue = this;
      if (!vue.per_page) {
        vue.tab = vue.full_tab;
        return;
      }
      let len = vue.full_tab.length;
      vue.calcPage();
      vue.tab = [];
      for (let i=vue.page_start; i<vue.page_end && i<len; ++i) {
         vue.tab.push(vue.full_tab[i]);
      }
      vue.tab.forEach(function(item) {
        vue.refresh(item);
      });
    },
    calcPage: function() {
      let vue = this;
      let len = vue.full_tab.length;
      vue.page_start = (0|vue.per_page) * vue.cur_page;
      vue.page_end = (0|vue.page_start) + (0|vue.per_page);
      //console.log("calc",len,JSON.stringify(vue.page_start),JSON.stringify(vue.page_end),JSON.stringify(vue.cur_page),JSON.stringify(vue.last_page));
    },
    prevPage: function() {
      let vue = this;
      //console.log("prevPage");
      if (vue.cur_page <= 0) {
         return;
      }
      vue.cur_page--;
      vue.updateTab();
    },
    nextPage: function() {
      let vue = this;
      //console.log("nextPage");
      vue.calcPage();
      if (vue.page_end >= vue.full_tab.length) {
         /* Current page is not full or at very end */
         vue.$emit("action",vue,"fetchMore");
         return;
      }
      vue.cur_page++;
      vue.updateTab();
      if (vue.page_end >= vue.full_tab.length) {
         /* New current page is not full or at very end */
         vue.$emit("action",vue,"fetchMore");
         return;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.pnthin {
  padding: 0 0.25rem;
  margin: 0;
}
</style>